
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"bd4c9326-fa2c-4c95-86d5-50e22413d506","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.7 11.9"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a658c639-5665-4bbb-867c-b594ab76e1dc","transform":"translate(-1.2)"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h12v12H0z"}})])]),_c('path',{attrs:{"d":"M8.4 8.5c0 1.6-1.1 3-2.4 3s-2.4-1.4-2.4-3v-5c0-1.6 1.1-3 2.4-3s2.4 1.4 2.4 3z","transform":"translate(-1.2)","fill":"none","stroke":"#333","stroke-miterlimit":"10"}}),_c('g',{attrs:{"clip-path":"url(#a658c639-5665-4bbb-867c-b594ab76e1dc)"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 4.8h9.7v2.27H0z"}})]),_c('path',{attrs:{"fill":"none","stroke":"#333","stroke-miterlimit":"10","d":"M4.8 3.2v5.5"}})])
          )
        }
      }
    